import * as angular from 'angular';
import { v4 as uuid } from 'uuid';
const OPEN_SIDEBAR_SEGMENT_EVENT = 'sidebar-open';
const CLOSE_SIDEBAR_SEGMENT_EVENT = 'sidebar-close';
export class SidebarService {
    static $inject = ['$rootScope', '$compile', '$controller', '$window', 'SegmentService'];
    constructor($rootScope, $compile, $controller, $window, SegmentService) {
        'ngInject';
        this.$rootScope = $rootScope;
        this.$compile = $compile;
        this.$controller = $controller;
        this.$window = $window;
        this.SegmentService = SegmentService;
    }
    showSidebar(options) {
        if (this.sidebarState?.element !== undefined) {
            this.closeSidebar();
        }
        const sidebarScope = this.$rootScope.$new();
        const sidebarElement = this.buildSidebarElement(options);
        const sidebarParent = angular.element(options.appendToElement ?? document.getElementsByTagName('body'));
        const inputs = {
            $scope: sidebarScope,
            $rootScope: this.$rootScope,
            ...options.inputs,
        };
        const sidebarController = this.$controller(options.controller, inputs);
        const compiledSidebarElement = this.$compile(sidebarElement)(sidebarController.$scope || sidebarScope);
        sidebarParent.append(compiledSidebarElement);
        sidebarElement.toggle();
        this.sidebarState = {
            element: sidebarElement,
            scope: sidebarScope,
            id: sidebarElement.getAttribute('id'),
            customId: options.id,
        };
        if (options.id) {
            this.SegmentService.createOrganizationTrack(`${options.id}-${OPEN_SIDEBAR_SEGMENT_EVENT}`);
        }
    }
    closeSidebar() {
        this.sidebarState.element.toggle();
        this.afterCloseSidebar();
    }
    afterCloseSidebar() {
        this.sidebarState.scope.$destroy();
        document.getElementById(this.sidebarState.id).remove();
        if (this.sidebarState.customId) {
            this.SegmentService.createOrganizationTrack(`${this.sidebarState.customId}-${CLOSE_SIDEBAR_SEGMENT_EVENT}`);
        }
        this.sidebarState = undefined;
    }
    buildSidebarElement(options) {
        const sidebarElement = document.createElement('bds-sidebar');
        sidebarElement.setAttribute('id', `sidebar-${options.id ?? uuid()}`);
        sidebarElement.setAttribute('margin', options.margin?.toString() ?? 'false');
        sidebarElement.setAttribute('sidebar-position', options.position ?? 'right');
        let sidebarWidth = options.width ?? 360;
        if (this.$window.innerWidth < sidebarWidth) {
            sidebarWidth = this.$window.innerWidth;
        }
        sidebarElement.setAttribute('width', `${sidebarWidth}px`);
        const sidebarBodyElement = document.createElement('div');
        sidebarBodyElement.setAttribute('slot', 'body');
        sidebarBodyElement.appendChild(document.createRange().createContextualFragment(options.template));
        sidebarElement.appendChild(sidebarBodyElement);
        sidebarElement.addEventListener('bdsToggle', (e) => {
            // If sidebar is closing
            if (!e.detail.value) {
                this.afterCloseSidebar();
            }
        });
        return sidebarElement;
    }
}
// Explicit AngularJS DI annotation for minification safety
// Order must match constructor parameter order
SidebarService.$inject = ['$rootScope', '$compile', '$controller', '$window', 'SegmentService'];
